import { z } from 'zod';

export const LanguageRow = z.object({
  lang_code: z.string().min(2).max(5),
  name: z.string().min(1),
  rtl: z.boolean(),
});
export type Language = z.infer<typeof LanguageRow>;

export const LANGUAGES: readonly Language[] = [
  { lang_code: 'pl', name: 'Polski', rtl: false },
  { lang_code: 'en', name: 'English', rtl: false },
  { lang_code: 'de', name: 'Deutsch', rtl: false },
  { lang_code: 'cs', name: 'Čeština', rtl: false },
  { lang_code: 'uk', name: 'Українська', rtl: false },
] as const;

LANGUAGES.forEach((l) => LanguageRow.parse(l));
